export class WorldUI {
  public worldListElement: JQuery = $('[data-name="world"]');
  public worldNameElement: JQuery = $('[data-name="worldname"]');
  public worldNameWrapperElement: JQuery = $('[data-name="worldname-wrapper"]');

  public onWorldChange(callback: (value: string) => void) {
    this.worldListElement.on('change', (event) => {
      callback(this.worldListElement.val() as string);
    });
  }
}
